import React, {Component} from 'react'
import Helmet from 'react-helmet'
import styled, {injectGlobal, css} from 'styled-components'

injectGlobal(css`
  * {
    margin: 0;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    background: black;
    color: white;
  }

  html,
  body,
  #root,
  div[data-reactroot] {
    padding: 0;
    width: 100%;
    height: 100%;
  }

  body {
    font-family: Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: none;
  }

  article,
  blockquote,
  button,
  div,
  footer,
  input,
  main,
  ol,
  p,
  section,
  ul {
    position: relative;
    margin: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  blockquote {
    text-rendering: optimizeLegibility;
    font-weight: normal;
    margin: 0;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`)

const Wip = styled.div`
  padding: 2rem;
  h1, p {
    display: inline;
    font-size: 5.5vw;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: white;
  }
  a {
    display: inline-block;
    color: inherit;
    text-decoration: none;
    transform: scaleX(-1);
    &:hover {
      transform: scaleX(1);
      text-decoration: underline;
    }
  }
`

class App extends Component {
  render() {
    return (
      <div>
        <Helmet title='Hirn Faust Auge' />
        <Wip>
          <h1>Welcome to Hirn Faust Auge creative network. </h1><p>Our website is currently under construction – to get in touch say <a href='mailto:hello@hirnfaustauge.de' title='Send us a mail'>hello@hirnfaustauge.de</a> or visit us on <a href='https://www.facebook.com/hirnfaustauge/' title='Facebook'>Facebook</a>. Cheers.</p>
        </Wip>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js